// Scroll an element into view inside its own scroll container only.
// Element.scrollIntoView scrolls every scrollable ancestor, including boxes
// clipped with overflow: hidden (the two-column paket frame) and the
// document itself: the whole shell then slides up and leaves a blank band
// under it. This moves the nearest ancestor that actually scrolls, nothing
// else.

export type ScrollBlock = "start" | "center" | "nearest";

/** The nearest ancestor with overflow-y auto or scroll whose content overflows it. */
export function scrollParent(el: Element): HTMLElement | null {
  let box = el.parentElement;
  while (box && box !== document.body && box !== document.documentElement) {
    const oy = getComputedStyle(box).overflowY;
    if ((oy === "auto" || oy === "scroll") && box.scrollHeight > box.clientHeight) return box;
    box = box.parentElement;
  }
  return null;
}

export function scrollWithin(el: Element | null | undefined, { block = "nearest", smooth = false }: { block?: ScrollBlock; smooth?: boolean } = {}): void {
  if (!el) return;
  const box = scrollParent(el);
  if (!box) return;
  const outer = box.getBoundingClientRect();
  const inner = el.getBoundingClientRect();
  const offset = inner.top - outer.top + box.scrollTop;
  let top: number;
  if (block === "start") top = offset;
  else if (block === "center") top = offset - (box.clientHeight - inner.height) / 2;
  else if (inner.top < outer.top) top = offset;
  else if (inner.bottom > outer.bottom) top = offset - box.clientHeight + inner.height;
  else return;
  top = Math.max(0, top);
  if (typeof box.scrollTo === "function") box.scrollTo({ top, behavior: smooth ? "smooth" : "auto" });
  else box.scrollTop = top;
}
